import {
  AppMetricsRaw,
  AppMetricsV2Raw,
} from '../dto/top-apps/cube/raw/app-metrics.dto';
import { AppMetricsResult } from '../dto/top-apps/cube/mapped/app-metrics-result.dto';
import {
  IWorkingDaysAnalyticsActivityV2Enum,
  IWorkingDaysAnalyticsActivityEnum,
} from '../enum/working-days-analytics-activity.enum';
import { calculateAverage } from '../helpers/duration.helper';

export class AppMetricsMapper {
  persistenceToDomain(model: AppMetricsRaw): AppMetricsResult {
    return AppMetricsMapper.persistenceToDomain(model);
  }
  static persistenceToDomain(model: AppMetricsRaw): AppMetricsResult {
    const duration = Number(
      model[IWorkingDaysAnalyticsActivityEnum.TotalDuration] || '0'
    );
    const count = Number(model[IWorkingDaysAnalyticsActivityEnum.count] || '0');

    return {
      duration,
      count,
      callDuration: 0,
      callCount: 0,
      durationPerCount: calculateAverage(duration, count),
      callDurationPerCount: 0,
    };
  }
}

export class AppMetricsMapperV2 {
  persistenceToDomain(model: AppMetricsV2Raw): AppMetricsResult {
    return AppMetricsMapperV2.persistenceToDomain(model);
  }
  static persistenceToDomain(model: AppMetricsV2Raw): AppMetricsResult {
    const duration = Number(
      model[IWorkingDaysAnalyticsActivityV2Enum.TotalDuration] || '0'
    );
    const count = Number(
      model[IWorkingDaysAnalyticsActivityV2Enum.count] || '0'
    );
    const callDuration = Number(
      model[IWorkingDaysAnalyticsActivityV2Enum.TotalCallDuration] || '0'
    );
    const callCount = Number(
      model[IWorkingDaysAnalyticsActivityV2Enum.CallCount] || '0'
    );

    return {
      duration,
      count,
      callDuration,
      callCount,
      durationPerCount: duration / (count > 0 ? count : 1),
      callDurationPerCount: callDuration / (callCount > 0 ? callCount : 1),
    };
  }
}
